import React from 'react';
import {observer} from 'mobx-react';
import {DisplayTypeEnum} from '../render-v2-d';
import {documentImageSizeStyle, nonDocImageSizeStyle} from '../document-dimensions/document-dimensions';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    store: FrameBuilderStore;
};

export const CustomItem = observer(({store}: Props) => {
    const {frame, inchToPx} = store;
    const {customMatrix} = frame;

    return customMatrix?.flat().map((item, idx) => {
        const sizeStyle = item.displayType === DisplayTypeEnum.Doc ? documentImageSizeStyle(item, inchToPx) : nonDocImageSizeStyle(item, inchToPx);

        return (
            <img
                key={idx}
                src={item.url}
                alt={item.displayType}
                style={{
                    position: 'absolute',
                    top: item.top !== undefined ? inchToPx(item.top) : undefined,
                    bottom: item.bottom !== undefined ? inchToPx(item.bottom) : undefined,
                    ...sizeStyle,
                }}
            />
        );
    });
});
